/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { tradingLevels } from '../../../shared/models/Enum/tradingLevels';

@Component({
  selector: 'investment-objectives',
  template: require('./investment-objectives.component.html'),
})
export class InvestmentObjectiveComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);

    let steps;
    steps = this.flowManager.getStepArrays('investment-objective');

    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    const accountType = this.flowManager.getAccountType();
    if (accountType !== 'select-individual' && accountType !== 'select-joint') {
      this.form.inputs.applyMargins.showUp = false;
      // This sucks @todo find better way to wrap text in the form.js
      this.form.inputs.htmlMarginHelper.text =
        '<div class="row"><div class="col s12"><h3 class="investment-objectives-subheader">Option Application</h3></div></div>';
    }
  }

  ngOnInit() {
    if (this.form.stepsToComplete.length > 0) {
      this.form.buttons.inputs.next.path = `/${this.form.stepsToComplete[0].route}`;
    } else {
      this.form.buttons.inputs.next.path = '/investment-preferences';
    }
  }

  ngAfterViewInit() {
    this.finishedInit = true;
  }

  updateOptionValue(event) {
    this.optionTradingLevel();
    this.showOptionLevelHelpText();
  }

  showOptionLevelHelpText() {
    const specGroup = this.flowManager.getinvestmentSpeculationGroup();
    const applyOptions = this.appActions.getData(
      'GoalInformation.applyForOption',
      false
    );
    this.form.inputs.htmlOptionHelperBottom.showUp =
      specGroup !== 'speculation' && applyOptions === true;
  }

  optionTradingLevel() {
    let accountType = this.flowManager.getAccountType();
    const specGroup = this.flowManager.getinvestmentSpeculationGroup();
    const applyMargins = this.appActions.getData(
      'GoalInformation.applyForMargin',
      false
    );
    const applyOptions = this.appActions.getData(
      'GoalInformation.applyForOption',
      false
    );

    let newInvestmentLevel = null;
    let currentInvestmentLevel = this.appActions.getData(
      'appState.investmentLevel',
      -1
    );

    // Leave em all hidden!
    if (applyOptions === true) {
      // We can make this more complex if necessary, but for now: KISS
      if (specGroup !== 'speculation') {
        newInvestmentLevel = 1;
      } else {
        if (applyMargins === true) {
          newInvestmentLevel = 6;
        } else {
          if (
            accountType === 'select-individual' ||
            accountType === 'select-joint' ||
            accountType === 'select-custodial'
          ) {
            newInvestmentLevel = 2;
          } else {
            newInvestmentLevel = 3;
          }
        }
      }
    }
    if (applyMargins === true) {
      this.form.inputs.htmlMarginHelperBottom.showUp = true;
    } else {
      this.form.inputs.htmlMarginHelperBottom.showUp = false;
    }

    // Change detection!
    if (currentInvestmentLevel !== newInvestmentLevel) {
      this.appActions.setData('appState.investmentLevel', newInvestmentLevel);
      this.appActions.setData(
        'GoalInformation.optionLevel',
        newInvestmentLevel
      ); // Will trigger invalid

      if (this.finishedInit === true) {
        for (let index = 0; index < tradingLevels.length; index++) {
          const element = document.getElementById(tradingLevels[index]);
          if (element) element.checked = false;
        }
      }
    }

    this.showOptionLevelHelpText();
  }
}
